declare namespace $ {

	type $mol_view__sub_shm_ba_summary_card_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_summary_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_summary_card extends $mol_view {
		click( next?: any ): any
		Title( ): $mol_view
		Value( ): $mol_view
		title( ): string
		value( ): string
		selected( ): boolean
		attr( ): ({ 
			'shm_ba_summary_card_selected': ReturnType< $shm_ba_summary_card['selected'] >,
		})  & ReturnType< $mol_view['attr'] >
		event( ): ({ 
			click( next?: ReturnType< $shm_ba_summary_card['click'] > ): ReturnType< $shm_ba_summary_card['click'] >,
		})  & ReturnType< $mol_view['event'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map